import { ArchiveVisibilityContext } from "@/shared/hooks";
import { ReactNode } from "react";

interface ArchiveVisibilityProviderProps {
    children: ReactNode;
}

export function ArchiveVisibilityProvider({ children }: ArchiveVisibilityProviderProps) {
    return <ArchiveVisibilityContext value={true}>{children}</ArchiveVisibilityContext>;
}
